import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';
import { InputPhoneComponent } from './components';

@NgModule({
  declarations: [InputPhoneComponent],
  imports: [CommonModule, FormWrapperModule, TranslateModule, NgxIntlTelInputModule, FormWrapperModule],
  exports: [InputPhoneComponent],
})
export class InputPhoneModule {}
